import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { RICambioProgramaContent } from './components/RICambioProgramaContent';

export default function RICambioProgramaDetalle() {
    return (
        <>
            <MainContent
                component={<RICambioProgramaContent />}
                titulo='Cambio de programa'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
